interface ServicesPageSchema {
    pageTitle: string;
    pageDescription: string;
    pageKeywords: string;
    canonicalUrl: string;
    contactSchema: {
        "@context": string;
        "@type": string;
        name: string;
        description: string;
        url: string;
        telephone: string;
        address: {
            "@type": string;
            addressLocality: string;
            addressRegion: string;
            addressCountry: string;
        };
        serviceType: string[];
        areaServed: string;
    };
    contactSchemaJson: string;
}

const pageTitle = "Contact MASA HILLS Health Services | home care Agency Dallas-Fort Worth";
const pageDescription = "Contact MASA HILLS Health Services for professional home care services in Dallas-Fort Worth. Call (469) 573-0176 for elderly care, senior care, and in-home care services.";
const pageKeywords = "contact home care agency, Dallas Fort Worth home care, elderly care contact, senior care services contact";
const canonicalUrl = "https://masahillshealthservices.com/contact";

const contactSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "MASA HILLS Health Services",
    "description": "Contact MASA HILLS Health Services for professional home care services in Dallas-Fort Worth.",
    "url": "https://masahillshealthservices.com/contact",
    "telephone": "+14695730176",
    "address": {
        "@type": "3410 Texas Dr, Sachse, TX 75048",
        "streetAddress": "3410 Texas Dr",
        "addressLocality": "Sachse",
        "addressRegion": "TX",
        "postalCode": "75048",
        "addressCountry": "US"
    },
    "serviceType": [
        "Home Care Services",
        "Elderly Care",
        "Senior Care"
    ],
    "areaServed": "Dallas-Fort Worth, Texas"
};

const contactSchemaJson = JSON.stringify(contactSchema, null, 2);
const ContactSchemaData: ServicesPageSchema = {
    pageTitle,
    pageDescription,
    pageKeywords,
    canonicalUrl,
    contactSchema,
    contactSchemaJson
};

export default ContactSchemaData;